module.exports = __webpack_public_path__ + "static/media/charles-kVg2DQTAK7c-unsplash.14174961.jpg";